import { render, staticRenderFns } from "./tabZujianChild1.vue?vue&type=template&id=d8adbe34&"
import script from "./tabZujianChild1.vue?vue&type=script&lang=js&"
export * from "./tabZujianChild1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabZujianChild1.vue"
export default component.exports